import React, { createContext } from "react";

const UIContext = createContext({
  pageTitle: "",
  setPageTitle: (_: string) => {},
});

export const UIProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [pageTitle, setPageTitle] = React.useState("");

  return (
    <UIContext.Provider
      value={{
        pageTitle,
        setPageTitle,
      }}
    >
      {children}
    </UIContext.Provider>
  );
};

export default UIContext;
